export const socialsData = {
    github: 'https://github.com/dnyaneshwarmagar',
    linkedIn: 'https://www.linkedin.com/in/dnyaneshm/',
    instagram: 'https://www.instagram.com/dnyaneshm_1.618/?hl=en',
    codepen: 'https://codepen.io/dnyaneshwarmagar',
    twitter: 'https://twitter.com/Dnyaneshm5',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@dnyaneshwarmagar276',
    stackOverflow: 'https://stackoverflow.com/users/17801262/dnyaneshwar-magar',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://www.youtube.com/channel/UCwuyt4uVsDthScIqCLtzVMg/featured',
    facebook: 'https://www.facebook.com/vishwajitkmagar',
}